var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Find & Combine Analytics","icon":"piggy-bank","css-class":"analytics-find-combine","default-label":"Find & Combine","section-specs":_setup.sectionSpecs}},[_c(_setup.PensionMetrics,{ref:"pensionRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }